@if(!reviewComponent) {
<div class="local-reviewer-component"
  *ngIf="proposalStatus !== 'pending governance review' && userRoleTitle == 'coordinator'">
  <p><strong>Responses</strong></p>

  @if(showHideLIFCModal) {
  <div id="confirmationBox">
    <ng-container>
      <ng-template [ngTemplateOutlet]="confirmationModal"></ng-template>
    </ng-container>
  </div>
  }

  <!-- Local duedate concur by date -->
  <form nz-form [formGroup]="localSecretaryForm" nzLayout="vertical">
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="14">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Local  Reviewer Due By Date (Applies to All)</nz-form-label>
          <nz-form-control [@formControlAnimation] >
            <nz-date-picker formControlName="dueDate" [(ngModel)]="localSecretaryFormModel.dueDate"
              nzPlaceHolder="mm/dd/yyyy" style="width: 100%" (ngModelChange)="selectDueByDate($event)"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="14" style="display: none;">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Local Reviewer Concur By Date (Applies to All)</nz-form-label>
          <nz-form-control [@formControlAnimation]>
            <nz-date-picker formControlName="concurDate" [(ngModel)]="localSecretaryFormModel.concurDate"
              nzPlaceHolder="mm/dd/yyyy" style="width: 100%"
              (ngModelChange)="selectConcurByDate($event)"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </form>

  <!-- Local Legal -->
  <form nz-form [formGroup]="localLegalForm" nzLayout="vertical" *ngIf="(localLegalFormModel?.localLegal?.length || 0) > 0">
    <div nz-row nzGutter="8">      
      <div nz-col nzSpan="14" class="left-side-form">
        <!-- dropdown input form -->
        <div class="left-side-form-dropdown">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Legal</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-select nzShowSearch
                         [nzServerSearch]="true" nzMode="multiple"
                         formControlName="localLegal" [(ngModel)]="localLegalFormModel.localLegal"
                         [nzSuffixIcon]="legalemplate" (nzOnSearch)="searchGroupMember($event, 'localLegal')"
                         (ngModelChange)="onGroupMemberChange($event)">
                <ng-container *ngFor="let data of localLegalDefaultMember">
                  <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
                </ng-container>
              </nz-select>

              <ng-template #legalemplate>
                <span nz-icon nzType="user" nzTheme="outline"></span>
              </ng-template>
              

            </nz-form-control>
          </nz-form-item>
        </div>
        <!-- comments input field -->
        <div class="left-side-form-comments">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Comments</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <textarea nz-input formControlName="legalComments"
                [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-col nzSpan="7" nzOffset="1" class="right-side-action-buttons">
        <!-- Concurrence status -->
        <span> Concurrence: <br> {{legalConcurrence}} </span>
        <!-- Resend Request toggle button -->
        <span>
          <nz-form-item>
            <nz-form-label [@formLabelAnimation] class="pb-0">Resend Request</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-switch formControlName="localLegalSwitch" (ngModelChange)="localLegalFormModel.localLegalSwitch"
                (ngModelChange)="resetApprovalToggle($event, 'localifclegal')"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </span>
        <!-- email icon -->
        <span>
          <nz-form-item>
            <a (click)="sendReminderEmail()"><span nz-icon nzType="mail" nzTheme="twotone" style="font-size: 2.5rem;"></span></a>
          </nz-form-item>
        </span>
      </div>
    </div>
  </form>

  <!-- Local Controllers -->
  <form nz-form [formGroup]="localControllersForm" nzLayout="vertical" *ngIf="(localControllersFormModel?.localControllers?.length || 0) > 0">
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="14" class="left-side-form">
        <!-- dropdown input form -->
        <div class="left-side-form-dropdown">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Finance</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-select nzShowSearch 
              [nzServerSearch]="true" nzMode="multiple"
             formControlName="localControllers" [(ngModel)]="localControllersFormModel.localControllers"
              [nzSuffixIcon]="ControllersTemplate" (nzOnSearch)="searchGroupMember($event, 'localControllers')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localControllersDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #ControllersTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>

            </nz-form-control>
          </nz-form-item>
        </div>
        <!-- comments input field -->
        <div class="left-side-form-comments">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Comments</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <textarea nz-input formControlName="controllersComments"
                [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-col nzSpan="7" nzOffset="1" class="right-side-action-buttons">
        <!-- Concurrence status -->
        <span> Concurrence: <br> {{controllersConcurrence}} </span>
        <!-- Resend Request toggle button -->
        <span>
          <nz-form-item>
            <nz-form-label [@formLabelAnimation] class="pb-0">Resend Request</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-switch formControlName="localControllersSwitch"
                (ngModelChange)="resetApprovalToggle($event, 'localifccontrollers')"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </span>
        <!-- email icon -->
        <span>
          <nz-form-item>
            <a (click)="sendReminderEmail()"><span nz-icon nzType="mail" nzTheme="twotone" style="font-size: 2.5rem;"></span></a>
          </nz-form-item>
        </span>
      </div>
    </div>
  </form>

  <!-- Local Tax -->
  <form nz-form [formGroup]="localTaxForm" nzLayout="vertical" *ngIf="(localTaxFormModel?.localTax?.length || 0) > 0">
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="14" class="left-side-form">
        <!-- dropdown input form -->
        <div class="left-side-form-dropdown">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Tax</nz-form-label>
            <nz-form-control [@formControlAnimation]>

              <nz-select nzShowSearch 
              [nzServerSearch]="true" nzMode="multiple"
             formControlName="localTax" [(ngModel)]="localTaxFormModel.localTax"
              [nzSuffixIcon]="taxTemplate" (nzOnSearch)="searchGroupMember($event, 'localTax')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localTaxDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #taxTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>

            </nz-form-control>
          </nz-form-item>
        </div>
        <!-- comments input field -->
        <div class="left-side-form-comments">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Comments</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <textarea nz-input formControlName="taxComments"
                [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-col nzSpan="7" nzOffset="1" class="right-side-action-buttons">
        <!-- Concurrence status -->
        <span> Concurrence: <br> {{taxConcurrence}} </span>
        <!-- Resend Request toggle button -->
        <span>
          <nz-form-item>
            <nz-form-label [@formLabelAnimation] class="pb-0">Resend Request</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-switch formControlName="localTaxSwitch"
                (ngModelChange)="resetApprovalToggle($event, 'localifctax')"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </span>
        <!-- email icon -->
        <span>
          <nz-form-item>
            <a (click)="sendReminderEmail()"><span nz-icon nzType="mail" nzTheme="twotone" style="font-size: 2.5rem;"></span></a>
          </nz-form-item>
        </span>
      </div>
    </div>
  </form>

  <!-- Local Treasury-->
  <form nz-form [formGroup]="localTreasuryForm" nzLayout="vertical" *ngIf="(localTreasuryFormModel?.localTreasury?.length || 0) > 0">
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="14" class="left-side-form">
        <div class="left-side-form-dropdown">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Treasury</nz-form-label>
            <nz-form-control [@formControlAnimation]>

              <nz-select nzShowSearch 
              [nzServerSearch]="true" nzMode="multiple"
             formControlName="localTreasury" [(ngModel)]="localTreasuryFormModel.localTreasury"
              [nzSuffixIcon]="treasuryTemplate" (nzOnSearch)="searchGroupMember($event, 'localTreasury')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localTreasuryDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #treasuryTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>

            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="left-side-form-comments">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Comments</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <textarea nz-input formControlName="treasuryComments"
                [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-col nzSpan="7" nzOffset="1" class="right-side-action-buttons">
        <span> Concurrence: <br> {{treasuryConcurrence}} </span>
        <span>
          <nz-form-item>
            <nz-form-label [@formLabelAnimation] class="pb-0">Resend Request</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-switch formControlName="localTreasurySwitch"
                (ngModelChange)="resetApprovalToggle($event, 'localifctreasury')"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </span>
        <span>
          <nz-form-item>
            <a (click)="sendReminderEmail()"><span nz-icon nzType="mail" nzTheme="twotone" style="font-size: 2.5rem;"></span></a>
          </nz-form-item>
        </span>
      </div>
    </div>
  </form>


  <!-- Local Bu Management-->
  <form nz-form [formGroup]="localBUForm" nzLayout="vertical" *ngIf="(localBUFormModel?.localBU?.length || 0) > 0">
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="14" class="left-side-form">
        <div class="left-side-form-dropdown">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>BU Management</nz-form-label>
            <nz-form-control [@formControlAnimation]>

              <nz-select nzShowSearch 
              [nzServerSearch]="true" nzMode="multiple"
             formControlName="localBU" [(ngModel)]="localBUFormModel.localBU"
              [nzSuffixIcon]="BUTemplate" (nzOnSearch)="searchGroupMember($event, 'localBU')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localBUDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #BUTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>

            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="left-side-form-comments">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Comments</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <textarea nz-input formControlName="buComments"
                [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-col nzSpan="7" nzOffset="1" class="right-side-action-buttons">
        <span> Concurrence: <br> {{buConcurrence}} </span>
        <span>
          <nz-form-item>
            <nz-form-label [@formLabelAnimation] class="pb-0">Resend Request</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-switch formControlName="localBUSwitch"
                (ngModelChange)="resetApprovalToggle($event, 'localifcBU')"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </span>
        <span>
          <nz-form-item>
            <a (click)="sendReminderEmail()"><span nz-icon nzType="mail" nzTheme="twotone" style="font-size: 2.5rem;"></span></a>
          </nz-form-item>
        </span>
      </div>
    </div>
  </form>

  <!-- Local Others-->
  <form nz-form [formGroup]="localOthersForm" nzLayout="vertical" *ngIf="(localOthersFormModel?.localOthers?.length || 0) > 0">
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="14" class="left-side-form">
        <div class="left-side-form-dropdown">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Others</nz-form-label>
            <nz-form-control [@formControlAnimation]>

              <nz-select nzShowSearch 
              [nzServerSearch]="true" nzMode="multiple"
             formControlName="localOthers" [(ngModel)]="localOthersFormModel.localOthers"
              [nzSuffixIcon]="othersTemplate" (nzOnSearch)="searchGroupMember($event, 'localOthers')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localOthersDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #othersTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>

            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="left-side-form-comments">
          <nz-form-item>
            <nz-form-label [@formLabelAnimation]>Comments</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <textarea nz-input formControlName="othersComments"
                [nzAutosize]="{ minRows: 3, maxRows: 10 }"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-col nzSpan="7" nzOffset="1" class="right-side-action-buttons">
        <span> Concurrence: <br> {{othersConcurrence}} </span>
        <span>
          <nz-form-item>
            <nz-form-label [@formLabelAnimation] class="pb-0">Resend Request</nz-form-label>
            <nz-form-control [@formControlAnimation]>
              <nz-switch formControlName="localOthersSwitch"
                (ngModelChange)="resetApprovalToggle($event, 'localifcOthers')"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </span>
        <span>
          <nz-form-item>
            <a (click)="sendReminderEmail()"><span nz-icon nzType="mail" nzTheme="twotone" style="font-size: 2.5rem;"></span></a>
          </nz-form-item>
        </span>
      </div>
    </div>
  </form>

</div>

<!--  -->

<div *ngIf="proposalStatus == 'pending governance review' && userRoleTitle == 'coordinator'">
  <label *ngIf="localReviewerErrorMsg" style="color: red;">{{ localReviewerErrorMsg }}</label>
  
  <form nz-form [formGroup]="coordianatorLocalForm" nzLayout="vertical">
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="14">
        <nz-form-item>
          <nz-form-label nzRequired [@formLabelAnimation]>Local Due By Date (Applies to All)</nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorTipForDueDate('dueDate')" >
            <nz-date-picker formControlName="dueDate" [(ngModel)]="coordianatorLocalFormModel.dueDate"
              nzPlaceHolder="mm/dd/yyyy" style="width: 100%" (ngModelChange)="selectDueByDate($event)"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="7" style="display: none;">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Local Concur By Date (Applies to All)</nz-form-label>
          <nz-form-control [@formControlAnimation]>
            <nz-date-picker formControlName="concurDate" [(ngModel)]="coordianatorLocalFormModel.concurDate"
              nzPlaceHolder="mm/dd/yyyy" style="width: 100%"
              (ngModelChange)="selectConcurByDate($event)"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <!--  -->
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="7">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Legal</nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorTip('localLegalForm','localLegal')" [@formControlAnimation]>
            <nz-select nzShowSearch nzPlaceHolder="Select one or more reviewer" [nzServerSearch]="true" nzMode="multiple"
             formControlName="localLegal" [(ngModel)]="coordianatorLocalFormModel.localLegal"
              [nzSuffixIcon]="legalemplate" (nzOnSearch)="searchGroupMember($event, 'localLegal')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localLegalDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #legalemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="7">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Finance</nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorTip('localControllersForm','localControllers')" [@formControlAnimation]>
            <nz-select nzShowSearch nzPlaceHolder="Select one or more reviewer" [nzServerSearch]="true" nzMode="multiple"
             formControlName="localControllers" [(ngModel)]="coordianatorLocalFormModel.localControllers"
              [nzSuffixIcon]="ControllersTemplate" (nzOnSearch)="searchGroupMember($event, 'localControllers')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localControllersDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #ControllersTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <!--  -->
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="7">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Tax</nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorTip('localTaxForm','localTax')" [@formControlAnimation]>
            <nz-select nzShowSearch nzPlaceHolder="Select one or more reviewer" [nzServerSearch]="true" nzMode="multiple"
             formControlName="localTax" [(ngModel)]="coordianatorLocalFormModel.localTax"
              [nzSuffixIcon]="taxTemplate" (nzOnSearch)="searchGroupMember($event, 'localTax')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localTaxDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #taxTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="7">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Treasury</nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorTip('localTreasuryForm','localTreasury')" [@formControlAnimation]>
            <nz-select nzShowSearch nzPlaceHolder="Select one or more reviewer" [nzServerSearch]="true" nzMode="multiple"
            formControlName="localTreasury" [(ngModel)]="coordianatorLocalFormModel.localTreasury"
             [nzSuffixIcon]="treasuryTemplate" (nzOnSearch)="searchGroupMember($event, 'localTreasury')"
             (ngModelChange)="onGroupMemberChange($event)">
            <ng-container *ngFor="let data of localTreasuryDefaultMember">
               <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
             </ng-container>
           </nz-select>
            <ng-template #treasuryTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzGutter="8">
      <div nz-col nzSpan="7">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>BU Management</nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorTip('localBUForm','localBU')" [@formControlAnimation]>
            <nz-select nzShowSearch nzPlaceHolder="Select one or more reviewer" [nzServerSearch]="true" nzMode="multiple"
             formControlName="localBU" [(ngModel)]="coordianatorLocalFormModel.localBU"
              [nzSuffixIcon]="buTemplate" (nzOnSearch)="searchGroupMember($event, 'localBU')"
              (ngModelChange)="onGroupMemberChange($event)">
             <ng-container *ngFor="let data of localBUDefaultMember">
                <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
              </ng-container>
            </nz-select>
            <ng-template #buTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="7">
        <nz-form-item>
          <nz-form-label [@formLabelAnimation]>Others</nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorTip('localOthersForm','localOthers')" [@formControlAnimation]>
            <nz-select nzShowSearch nzPlaceHolder="Select one or more reviewer" [nzServerSearch]="true" nzMode="multiple"
            formControlName="localOthers" [(ngModel)]="coordianatorLocalFormModel.localOthers"
             [nzSuffixIcon]="othersTemplate" (nzOnSearch)="searchGroupMember($event, 'localOthers')"
             (ngModelChange)="onGroupMemberChange($event)">
            <ng-container *ngFor="let data of localOthersDefaultMember">
               <nz-option [nzValue]="data.defaultEmail" [nzLabel]="data.defaultEmail"></nz-option>
             </ng-container>
           </nz-select>
            <ng-template #othersTemplate>
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <!--  -->
  </form>
</div>
}

@if(reviewComponent) {
<div>
  <nz-table #basicTable [nzData]="approvalsRecords" [ngClass]="reviewComponent ? 'reviewPageBlurTable' : ''"
    [nzShowPagination]="approvalsRecords.length > 10 ? true : false">
    <thead>
      <tr>
        <th scope="col">Reviewer Type</th>
        <th scope="col">Approver</th>
        <th scope="col">Concur Date</th>
        <th scope="col">Due Date</th>
        <th scope="col">Concurrence</th>
        <th scope="col">Comment</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of approvalsRecords">
        <td>{{ data?.type?.replace("Local IFC","") }}</td>
        <td>{{ data?.fullName }}</td>
        <td>{{ data?.concurDate | date:'shortDate' }}</td>
        <td>{{ data?.dueDate | date:'shortDate' }}</td>
        <td>{{ data?.status == true ? 'Concurred' : data?.status == false ? 'Declined':'Pending' }}</td>
        <td>{{ data?.comment }}</td>
      </tr>
    </tbody>
  </nz-table>
  <div class="divReviewerComments">
  @if(isLocalReviewer){
  <p><strong>Reviewers Comments</strong></p>
  <textarea nz-input placeholder="Reviewernotes" (ngModelChange)="saveReviewerComments($event)"  [(ngModel)]="reviewerCommet"
  [nzAutosize]="{ minRows: 2, maxRows: 10 }" 
  ></textarea><p></p>
  }
</div>

</div>
}

<ng-template #confirmationModal>
  <nz-alert nzShowIcon nzType="info" [nzMessage]="confirmationModalHeading" [nzDescription]="descriptionTemplate"
    [nzAction]="actionTemplate"></nz-alert>
  <ng-template #descriptionTemplate>
    <p> {{confirmationModalContent}} </p>
  </ng-template>
  <ng-template #actionTemplate>
    <nz-space nzDirection="horizontal">
      <button nz-button nzType="primary" (click)="getConfirmation('yes')" class="mr-2">
        <span>Yes</span>
      </button>
      <button nz-button nzType="default" (click)="getConfirmation('no')">
        <span>No</span>
      </button>
    </nz-space>
  </ng-template>
</ng-template>
